module.exports = __webpack_public_path__ + "static/media/kuppiboost_bg.c5250300.png";